<template>
  <div v-if="!dismissed" class="modal-shadow saved_popup min-h-screen flex flex-col">
    <div class="inner">
      <div class="content">
        <div class="w-full flex justify-between modal_header p-6 title_line">
          <div class="modal_title mt-2">
            {{ phase === 'importing' ? 'Importing locations' : 'Import complete' }}
          </div>
          <button
            v-if="phase !== 'importing'"
            class="x_btn"
            @click="closeModal"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
        </div>

        <div class="modal_body flex flex-col content-center mt-6 px-6 pb-4">
          <div v-if="phase === 'importing'">
            <p class="text-left mb-4">
              Importing location {{ current }} of {{ total }}…
            </p>
            <div class="w-full bg-gray-200 rounded h-3 mb-4 overflow-hidden">
              <div
                class="bg-green-custom h-3 rounded transition-all"
                :style="{ width: progressPercent + '%' }"
              />
            </div>
          </div>

          <div v-else>
            <p class="text-left mb-4">
              <strong>Created:</strong> {{ summary.created }}
              &nbsp;|&nbsp;
              <strong>Failed:</strong> {{ summary.failed }}
            </p>

            <div v-if="summary.successes.length" class="mb-4 text-left">
              <p class="font-bold mb-2">Created locations</p>
              <ul class="list-disc pl-5 max-h-32 overflow-y-auto">
                <li v-for="item in summary.successes" :key="'ok-' + item.rowIndex">
                  Row {{ item.rowIndex }}: {{ item.locationName }}
                </li>
              </ul>
            </div>

            <div v-if="summary.failures.length" class="text-left">
              <p class="font-bold mb-2">Failed rows</p>
              <div class="max-h-48 overflow-y-auto border rounded">
                <table class="w-full text-sm">
                  <thead>
                    <tr class="border-b bg-gray-50">
                      <th class="text-left p-2">Row</th>
                      <th class="text-left p-2">Location name</th>
                      <th class="text-left p-2">Reason</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in summary.failures"
                      :key="'fail-' + item.rowIndex"
                      class="border-b"
                    >
                      <td class="p-2">{{ item.rowIndex }}</td>
                      <td class="p-2">{{ item.locationName || '—' }}</td>
                      <td class="p-2">{{ item.message }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="phase !== 'importing'"
          class="btn_line flex justify-end w-full px-6 py-4 border-t modal_footer"
        >
          <button
            type="button"
            @click="closeModal"
            class="this_button py-3 px-4 border rounded bg-white hover:bg-gray-100"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LocationsCsvImportModal',
  props: {
    rows: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dismissed: false,
      phase: 'importing',
      current: 0,
      total: 0,
      summary: {
        created: 0,
        failed: 0,
        failures: [],
        successes: [],
      },
    };
  },
  computed: {
    progressPercent() {
      if (!this.total) {
        return 0;
      }
      return Math.round((this.current / this.total) * 100);
    },
  },
  async mounted() {
    this.total = this.rows.length;
    await this.runImport();
  },
  methods: {
    closeModal() {
      this.dismissed = true;
      this.$emit('finished');
    },
    async runImport() {
      try {
        const sessionRes = await this.$http.postAuth(
          `${this.$http.apiUrl()}/locations/import-csv/session`,
          { totalRows: this.total },
        );
        const sessionId = sessionRes?.data?.sessionId;
        if (!sessionId) {
          throw new Error('Could not start import session');
        }

        for (let i = 0; i < this.rows.length; i++) {
          this.current = i + 1;
          await this.$http.postAuth(
            `${this.$http.apiUrl()}/locations/import-csv/row`,
            {
              sessionId,
              rowIndex: i + 1,
              row: this.rows[i],
            },
          );
        }

        const completeRes = await this.$http.postAuth(
          `${this.$http.apiUrl()}/locations/import-csv/session/complete`,
          { sessionId },
        );
        this.summary = {
          created: completeRes?.data?.created ?? 0,
          failed: completeRes?.data?.failed ?? 0,
          failures: completeRes?.data?.failures ?? [],
          successes: completeRes?.data?.successes ?? [],
        };
      } catch (e) {
        console.error(e);
        this.summary = {
          created: 0,
          failed: this.total,
          failures: [
            {
              rowIndex: 0,
              locationName: '',
              message: 'Import failed unexpectedly',
            },
          ],
          successes: [],
        };
      }
      this.phase = 'complete';
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-shadow {
  position: fixed;
  top: 0;
  left: 0;
  min-height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.39);
  z-index: 1100;
}
.modal_header {
  border-radius: 8px 8px 0 0;
  border-bottom: none;
}
.saved_popup {
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100vw;
}
.inner {
  margin: 40px auto;
  max-width: 640px;
  background: #fff;
  border-radius: 8px;
}
</style>
